module.exports = __webpack_public_path__ + "img/hcml_gallery3.c33cd229.jpg";